<script setup lang="ts">
import { computed, ref } from "vue";

defineOptions({
    inheritAttrs: false, // Prevent Vue from automatically passing non-props attributes
});

const props = defineProps({
    severity: {
        type: String,
        default: "secondary",
    },
    icon: {
        type: String,
        default: "pi pi-question-circle",
    },
    content: {
        type: String,
        default: "",
    },
    visible: {
        type: Boolean,
        default: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    backgroundColor: {
        type: String,
        default: "transparent",
    },
});

const disabled = computed(() => props.disabled);
const visible = computed(() => props.visible);

const infoText = ref();

function toggleInfo(event: MouseEvent) {
    infoText.value.toggle(event);
}
</script>

<template>
    <Button
        type="button"
        :severity="props.severity"
        :icon="props.icon"
        @click="toggleInfo"
        :style="`background-color: ${backgroundColor}; border: 1px ${backgroundColor};`"
        :visible="visible"
        :disabled="disabled"
        v-bind="$attrs"
    />
    <Popover ref="infoText">
        <div class="flex flex-col w-100" v-html="props.content"></div>
    </Popover>
</template>
